var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.3697 12.9392H19.6564M24.8942 30.3984H9.18091",
    stroke: "#A9A9A9",
    strokeWidth: 3.49184,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.132 35.6362C33.0248 35.6362 35.3698 33.2911 35.3698 30.3984C35.3698 27.5057 33.0248 25.1606 30.132 25.1606C27.2393 25.1606 24.8943 27.5057 24.8943 30.3984C24.8943 33.2911 27.2393 35.6362 30.132 35.6362Z",
    stroke: "#A9A9A9",
    strokeWidth: 3.49184,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6726 18.1769C15.5653 18.1769 17.9103 15.8319 17.9103 12.9392C17.9103 10.0464 15.5653 7.70142 12.6726 7.70142C9.77984 7.70142 7.43481 10.0464 7.43481 12.9392C7.43481 15.8319 9.77984 18.1769 12.6726 18.1769Z",
    stroke: "#A9A9A9",
    strokeWidth: 3.49184,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilters);
export default __webpack_public_path__ + "static/media/filters.6a06ad3b16d17dfdf7fdda75257dd878.svg";
export { ForwardRef as ReactComponent };